import { defineMessages } from 'react-intl';

export default defineMessages({
  addedBy: 'Dodał: ',
  date: 'Data dodania: ',
  download: 'Pobierz',
  loadAgain: 'Załaduj ponownie',
});
